/** A visit of at least three minutes reads as Engaged; the rest Glanced. */
export const ENGAGED_THRESHOLD_SECONDS = 180

export const ENGAGED_LABEL = `Engaged`
export const GLANCED_LABEL = `Glanced`
export const NO_VIEWS_LABEL = `No views yet`

export const isEngaged = (viewDuration: number): boolean =>
  viewDuration >= ENGAGED_THRESHOLD_SECONDS

export const formatTimeAgo = (
  dateString: string,
  now: Date = new Date(),
): string => {
  const date = new Date(dateString)
  if (Number.isNaN(date.getTime())) {
    return `Just now`
  }

  const diffMinutes = Math.floor((now.getTime() - date.getTime()) / (1000 * 60))
  const diffHours = Math.floor(diffMinutes / 60)
  const diffDays = Math.floor(diffHours / 24)

  if (diffDays > 0) {
    return diffDays === 1 ? `1 day ago` : `${diffDays} days ago`
  }
  if (diffHours > 0) {
    return diffHours === 1 ? `1 hour ago` : `${diffHours} hours ago`
  }
  if (diffMinutes > 0) {
    return diffMinutes === 1 ? `1 minute ago` : `${diffMinutes} minutes ago`
  }
  return `Just now`
}

export const formatViewDuration = (seconds: number): string => {
  const whole = Math.max(0, Math.floor(seconds))
  const minutes = Math.floor(whole / 60)
  const remainingSeconds = whole % 60

  return minutes > 0
    ? `${minutes}m ${remainingSeconds}s`
    : `${remainingSeconds}s`
}
